<template>
  <div class='panel'>
    <Frame :sum="leftSum" align="left"/>
    <Price :price="price" :color="color"/>
    <Frame :sum="rightSum"/>
  </div>
</template>

<script>
import Frame from './Frame.vue';
import Price from './Price.vue';

// Коэффициенты для отображения итогового джекпота
const SUM_LEFT_MULTIPLIER = 200; // для игр: Бой 1 и Линии 1
const SUM_RIGHT_MULTIPLIER = 300; // для игр: Бой 2 и Линии 2

export default {
  name: 'MainPanel',
  components: { Frame, Price },
  props: {
    price: Number,
    sum: String,
    index: Number,
  },
  computed: {
    baseSum() {
      return parseInt(this.sum, 10);
    },
    leftSum() {
      return this.baseSum + SUM_LEFT_MULTIPLIER * this.price;
    },
    rightSum() {
      return this.baseSum + SUM_RIGHT_MULTIPLIER * this.price;
    },
    color() {
      switch (this.index) {
        case 0:
          return 'red';
        case 1:
          return 'orange';
        case 2:
          return 'green';
        case 3:
          return 'blue';
        default:
          return 'gray';
      }
    },
  },
};
</script>

<style scoped>
.panel {
  position: relative;
  justify-content: center;
  display: flex;
  align-items: center;
  margin: 4px 0;
  padding: 0 36px;
  width: 1028px;
  height: 126px;
  gap: 273px;
  border-radius: 24px;
  background: #1D1E1F;
  backdrop-filter: blur(16px);
}
</style>
